import { AppBar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/system';

const StyledAppBar = styled(AppBar)({
  zIndex: 900,
});

const MenuContainer = styled(Grid)(({ theme }) => ({
  paddingRight: theme.spacing(1),
  marginLeft: `-${theme.spacing(2)}`,

  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

const MainContainer = styled(Grid)(() => ({
  display: 'block',
  alignItems: 'center',
  width: '15%',
}));

const FilterContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    order: 2,
  },
}));

const BreadcrumbContainer = styled(Grid)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    alignItems: 'flex-start',
  },
}));

const NavigationContainer = styled(Grid)(({ theme }) => ({
  width: '100%',
  position: 'relative',
  display: 'none',

  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
}));

const ProgressBarContainer = styled('div')({
  height: '4px',
  backgroundColor: 'transparent',
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: '-4px',
});

export { 
  StyledAppBar,
  MenuContainer,
  MainContainer,
  FilterContainer,
  BreadcrumbContainer,
  NavigationContainer,
  ProgressBarContainer,
};
